module.exports = __webpack_public_path__ + "img/installment_lease_overview_icon03.dd9cd52b.svg";